import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { SITE_URL, IMG_DOMAIN } from '../config/domain';
import { useSEO } from './useSEO';
import { AVAILABLE_LANGUAGES } from '../config/languages';

const NOINDEX_PATHS = ['/auth', '/favorites', '/post-ad', '/user-favorites.php'];

const NOINDEX_QUERY_PARAMS = ['page', 'sort', 'filter', 'category', 'city', 'region'];

const DEFAULT_OG_IMAGE = `${SITE_URL}/ef.png`;

interface AutoSEOOptions {
  title?: string;
  description?: string;
  keywords?: string[];
  ogImage?: string;
}

export const useAutoSEO = (options: AutoSEOOptions = {}) => {
  const location = useLocation();

  const seoData = useMemo(() => {
    const pathname = location.pathname;
    const searchParams = new URLSearchParams(location.search);

    const shouldNoindex =
      NOINDEX_PATHS.some(p => pathname.startsWith(p)) ||
      NOINDEX_QUERY_PARAMS.some(param => searchParams.has(param));

    const canonicalUrl = `${SITE_URL}${pathname}`;

    const hreflang = AVAILABLE_LANGUAGES.filter(l => l.active).map(l => ({
      lang: l.code.replace('_', '-'),
      url: canonicalUrl,
    }));

    return {
      title: options.title || document.title,
      description: options.description || '',
      keywords: options.keywords || [],
      canonicalUrl,
      ogUrl: canonicalUrl,
      ogImage: options.ogImage || DEFAULT_OG_IMAGE,
      twitterImage: options.ogImage || DEFAULT_OG_IMAGE,
      twitterSite: '@escortfun',
      twitterCreator: '@escortfun',
      robots: shouldNoindex ? 'noindex, nofollow' : undefined,
      hreflang,
    };
  }, [location.pathname, location.search, options.title, options.description, options.keywords, options.ogImage]);

  useSEO(seoData);
};
